module.exports = __webpack_public_path__ + "static/media/KucoinVentures.2556f335.svg";